import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'


/**
 * 维修福列表
 * @param {Object} data 
 */
export function getPageList(data) {
  return fetch({
    url: '/financial/repair/fee/receivable/list',
    method: 'POST',
    data
  })
}


/**
 * 维修费导出
 * @param {Object} data 
 */
export function exportRepair(data) {
  return formAxios({
    url: '/financial/repair/fee/receivable/export',
    method: 'POST',
    data
  })
}


/**
 * 维修费添加
 * @param {Object} data 
 */
export function addRepair(data) {
  return fetch({
    url: '/financial/repair/fee/add',
    method: 'POST',
    data
  })
}


/**
 * 维修费删除
 * @param {Object} data 
 */
export function batchDelete(data) {
  return fetch({
    url: '/financial/repair/fee/receivableBatchDelete',
    method: 'POST',
    data
  })
}


/**
 * 设置费用
 * @param {Object} data 
 */
export function setFee(data) {
  return fetch({
    url: '/financial/repair/fee/receivable/setFee',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/MaintenanceFeeCollected/index.js